//
//
//
//

import mixin from '@/mixins'
import Util from '@/common/js/util'
import { mapGetters } from 'vuex'
import Common from '../common/js/common.js'
import GlobalApi from "../api/global";

export default {
  name: 'Authorize',
  mixins: [mixin],
  data () {
    return {
      searchJson: {}
    }
  },
  computed: {
    ...mapGetters({
      historyState: 'HistoryState'
    })
  },
  created () {
    window.localStorage.setItem("appType", this.$route.query.appType);
    if (Common.isWeiXin) {
      //如果在微信里面，进入授权业务
      this.init()
    } else {
      //如果不在微信里面，直接跳转落地页
      this.goHome()
    }
  },
  methods: {
    init() {
      const inviteCode = this.$route.query.inviteCode
      const url = this.$route.query.url
      this.onGotUserInfo(url, inviteCode, () => {
        this.goHome()
      })
    },
    goHome () {
      GlobalApi.getDicInfoByKey({ key: 'cattleDownloadDomain' }).then(data => {
        if (data.Status === 200) {
          data.Result.list.forEach(item=>{
            if (item.key === 'downUrl') {
              window.location.href = item.value
            }
          })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/Authorize.vue